import BaseModel from "./BaseModel";
import { formatDate } from "@/lib/date";

export class DeliveryCollectionLog extends BaseModel {
  /* eslint-disable-next-line */
  constructor(props) {
    super(props);
  }

  get logWriter() {
    if (this.rider) {
      return `${this.rider?.name}(라이더앱)`;
    } else {
      return "";
    }
  }

  renderCreatedAt(dateFormat = "yyyy-MM-dd HH:mm") {
    if (this.createdAt) {
      return formatDate(new Date(this.createdAt), dateFormat);
    } else {
      return "";
    }
  }

  renderCollectionType() {
    if (this.mainOffice) {
      return "본사확인";
    } else if (!!this.imagePath) {
      return "회수촬영";
    } else {
      return "회수스캔";
    }
  }
}
